import { render, staticRenderFns } from "./StopEffect.vue?vue&type=template&id=07b7478e&scoped=true"
import script from "./StopEffect.vue?vue&type=script&lang=js"
export * from "./StopEffect.vue?vue&type=script&lang=js"
import style0 from "./StopEffect.vue?vue&type=style&index=0&id=07b7478e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b7478e",
  null
  
)

export default component.exports